import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[fc-host]',
    standalone: false
})
export class FcDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
